// extracted by mini-css-extract-plugin
export var acitonButtons = "_m7-0";
export var additionalIcon = "_m7-f";
export var block = "_m7-1";
export var blockContent = "_m7-7";
export var blockDescription = "_m7-8";
export var blockIcon = "_m7-9";
export var blockTitle = "_m7-6";
export var border = "_m7-a";
export var center = "_m7-l";
export var edge = "_m7-b";
export var edgeLabel = "_m7-c";
export var edgePath = "_m7-d";
export var error = "_m7-e";
export var flowchart = "_m7-g";
export var flowchartContent = "_m7-h";
export var highlighted = "_m7-3";
export var hover = "_m7-4";
export var icon = "_m7-i";
export var left = "_m7-m";
export var navButton = "_m7-j";
export var navButtons = "_m7-k";
export var right = "_m7-n";
export var selected = "_m7-2";
export var small = "_m7-5";